export const ReservationStatus = {
  HOLD: "hold",
  CREATED: "created",
  PAID: "paid",
  CONFIRMED: "confirmed",
  ACTIVE: "active",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
} as const
export type ReservationStatus = typeof ReservationStatus[keyof typeof ReservationStatus]

export const PaymentStatus = {
  PENDING: "pending",
  PAID: "paid",
  REFUNDED: "refunded",
  FAILED: "failed",
} as const
export type PaymentStatus = typeof PaymentStatus[keyof typeof PaymentStatus]

export const PaymentMethod = {
  BANK_TRANSFER: "bank_transfer",
  QR_PAYMENT: "qr_payment",
  CASH: "cash",
  CARD: "card",
} as const
export type PaymentMethod = typeof PaymentMethod[keyof typeof PaymentMethod]

export const UserRole = {
  OWNER: "owner",
  MANAGER: "manager",
  ADMIN: "admin",
} as const
export type UserRole = typeof UserRole[keyof typeof UserRole]

export const SpotStatus = {
  AVAILABLE: "available",
  OCCUPIED: "occupied",
  MAINTENANCE: "maintenance",
} as const
export type SpotStatus = typeof SpotStatus[keyof typeof SpotStatus]

export const AccessCodeType = {
  GATE: "gate",
  TOILET: "toilet",
  SHOWER: "shower",
  WIFI: "wifi",
  KITCHEN: "kitchen",
} as const
export type AccessCodeType = typeof AccessCodeType[keyof typeof AccessCodeType]

export const EmailTemplateType = {
  RESERVATION_CONFIRMATION: "reservation_confirmation",
  PAYMENT_REMINDER: "payment_reminder",
  RECEIPT: "receipt",
  EXTENSION_CONFIRMATION: "extension_confirmation",
  CANCELLATION: "cancellation",
  MAGIC_LINK: "magic_link",
} as const
export type EmailTemplateType = typeof EmailTemplateType[keyof typeof EmailTemplateType]

export const NotificationChannel = {
  EMAIL: "email",
  SMS: "sms",
  PUSH: "push",
} as const
export type NotificationChannel = typeof NotificationChannel[keyof typeof NotificationChannel]

export const NotificationStatus = {
  SENT: "sent",
  DELIVERED: "delivered",
  FAILED: "failed",
} as const
export type NotificationStatus = typeof NotificationStatus[keyof typeof NotificationStatus]
